import axios from "axios";
import { server } from "../../server";

// Create product
export const createProduct = (productData) => async (dispatch) => {
  try {
    dispatch({ type: "productCreateRequest" });

   

    const { data } = await axios.post(`${server}/product/create-product`, productData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    dispatch({ type: "productCreateSuccess", payload: data.product });
  } catch (error) {
    console.log("Error response:", error.response); // Debugging line
    dispatch({ type: "productCreateFail", payload: error.response.data.message });
  }
};

// Get all products of a shop
export const getAllProductsShop = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getAllProductsShopRequest" });

    const { data } = await axios.get(`${server}/product/get-all-products-shop/${id}`);
    dispatch({ type: "getAllProductsShopSuccess", payload: data.products });
  } catch (error) {
    dispatch({ type: "getAllProductsShopFailed", payload: error.response.data.message });
  }
};

// Delete product of a shop
export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteProductRequest" });

    const { data } = await axios.delete(`${server}/product/delete-shop-product/${id}`, {
      withCredentials: true,
    });

    dispatch({ type: "deleteProductSuccess", payload: { message: data.message, id } });

  } catch (error) {
    dispatch({ type: "deleteProductFailed", payload: error.response.data.message });
  }
};

// Get all products with pagination and optional category filter
export const getAllProducts = (page = 1, limit = 30, category = null) => async (dispatch) => {
  try {
    dispatch({ type: "getAllProductsRequest" });

    const params = { page, limit };
    if (category) {
      params.category = category;
    }

    const { data } = await axios.get(`${server}/product/get-all-products`, {
      params,
    });

    dispatch({
      type: "getAllProductsSuccess",
      payload: {
        products: data.products,
        page: data.page,
        totalPages: data.totalPages,
        totalProducts: data.totalProducts,
      },
    });
  } catch (error) {
    dispatch({ type: "getAllProductsFailed", payload: error.response.data.message });
  }
};


// Fetch single product
export const getProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getProductRequest" });

    const { data } = await axios.get(`${server}/product/product/${id}`);
    dispatch({ type: "getProductSuccess", payload: data.product });
  } catch (error) {
    dispatch({ type: "getProductFail", payload: error.response.data.message });
  }
};

// Update product
export const updateProduct = (id, productData) => async (dispatch) => {
  try {
    dispatch({ type: "updateProductRequest" });

    const { data } = await axios.put(`${server}/product/update-product/${id}`, productData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    dispatch({ type: "updateProductSuccess", payload: data.product });
  } catch (error) {
    dispatch({ type: "updateProductFail", payload: error.response.data.message });
  }
};


// Clear errors and reset success state 
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: "clearErrors" });
  dispatch({ type: "resetSuccess" }); // Add an action to reset the success state
};
